import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import createApiService from "../../../../network";
import routeNames from "../../../../constants/routeNames";
import LockedTimelineModalView from "./LockedTimelineModalView";

class LockedTimelineModalContainer extends Component {
    constructor(props) {
        super(props);

        this.api = createApiService(axios);
    }

    onCloseButtonClick = () => {
        this.props.hideModal();

        if (this.props.isEndUser) {
            this.props.history.push(`${routeNames.selectCeremony}`);
        }
    };

    onFooterButtonClick = (blockId) => {
        this.props.hideModal();
        this.props.showBlockProcessingModal(blockId);
    };

    render() {
        return (
            <LockedTimelineModalView
                areAssetsCleanedUp={this.props.areAssetsCleanedUp}
                ceremonyMaster={this.props.ceremonyMaster}
                isVisible={this.props.isVisible}
                onCloseButtonClick={this.onCloseButtonClick}
                onFooterButtonClick={this.onFooterButtonClick}
            />
        );
    }
}

export default withRouter(LockedTimelineModalContainer);
